import { authReducer, initialAuth } from './authReducer'
import { uiReducer, initialUI } from './uiReducer'
import { possesReducer, initialPosses } from './possesReducer'
import { profilesReducer, initialProfiles } from './profilesReducer'
import { invitesReducer, initialInvites } from './invitesReducer'
import { meReducer, initialMe } from './meReducer'
import { kvReducer, initialKV } from './kvReducer'

export const initialState = {
  ui: initialUI,
  auth: initialAuth,
  me: initialMe,
  posses: initialPosses,
  profiles: initialProfiles,
  invites: initialInvites,
  kv: initialKV,
}

export default function mainReducer(state, action) {
  let newState = {
    ui: uiReducer(state.ui, action),
    auth: authReducer(state.auth, action),
    me: meReducer(state.me, action),
    posses: possesReducer(state.posses, action),
    profiles: profilesReducer(state.profiles, action),
    invites: invitesReducer(state.invites, action),
    kv: kvReducer(state.kv, action),
  }
  if (process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_SUPPRESS_STATE_LOGS !== 'true') {
    console.group(`%cACTION: ${action.type}`, 'color: blue; font-size: 0.8rem')
    console.log('ACTION: ', action)
    console.log('PREVIOUS STATE: ', state)
    console.log('CURRENT STATE: ', newState)
    console.groupEnd()
  }
  return newState
}
